module.exports = __webpack_public_path__ + "static/media/connections-android-mweb.f038fbe5.webp";